"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
class TwingNodeInclude extends node_1.TwingNode {
    constructor(expr, variables, only, ignoreMissing, lineno, columnno, tag = null) {
        let nodes = new Map();
        nodes.set('expr', expr);
        if (variables !== null) {
            nodes.set('variables', variables);
        }
        super(nodes, new Map([['only', only], ['ignore_missing', ignoreMissing]]), lineno, columnno, tag);
        this.type = node_1.TwingNodeType.INCLUDE;
    }
    compile(compiler) {
        compiler
            .addDebugInfo(this);
        if (this.getAttribute('ignore_missing')) {
            compiler
                .write('(() => {\n')
                .indent()
                .write('let template = null;\n')
                .write('try {\n')
                .indent()
                .write('template = ');
            this.addGetTemplate(compiler);
            compiler
                .raw(';\n')
                .outdent()
                .write('}\n')
                .write('catch (e) {\n')
                .indent()
                .write('if (e instanceof Runtime.TwingErrorLoader) {\n')
                .indent()
                .write('// ignore missing template\n')
                .outdent()
                .write('}\n')
                .write('else {\n')
                .indent()
                .write('throw e;\n')
                .outdent()
                .write('}\n')
                .outdent()
                .write('}\n')
                .write('if (template) {\n')
                .indent()
                .write('template.display(');
            this.addTemplateArguments(compiler);
            compiler
                .raw(');\n')
                .outdent()
                .write('}\n')
                .outdent()
                .write('})();\n');
        }
        else {
            this.addGetTemplate(compiler);
            compiler.raw('.display(');
            this.addTemplateArguments(compiler);
            compiler.raw(');\n');
        }
    }
    addGetTemplate(compiler) {
        compiler
            .write('this.loadTemplate(')
            .subcompile(this.getNode('expr'))
            .raw(', ')
            .repr(this.getTemplateName())
            .raw(', ')
            .repr(this.getTemplateLine())
            .raw(')');
    }
    addTemplateArguments(compiler) {
        if (!this.hasNode('variables')) {
            compiler.raw(this.getAttribute('only') === false ? 'context' : 'new Map()');
        }
        else if (this.getAttribute('only') === false) {
            compiler
                .raw('Runtime.merge(context, ')
                .subcompile(this.getNode('variables'))
                .raw(')');
        }
        else {
            compiler.subcompile(this.getNode('variables'));
        }
    }
}
exports.TwingNodeInclude = TwingNodeInclude;
